// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p6-6";
export var imgContainer = "_p6-3";
export var menuIcon = "_p6-5";
export var pillWrapper = "_p6-2";
export var pillsContainer = "_p6-1";
export var subscriptionCard = "_p6-0";
export var subscriptionLogo = "_p6-4";